import { captureElement } from "@utils/capture_utils";
import { jsPDF } from "jspdf";
import "svg2pdf.js";
import * as htmlToImage from 'html-to-image';


export const A4_SIZE = [2480, 3508];

export const clipCanvas = (canvas, start, height) => {
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, start, canvas.width, height);
  const can = document.createElement("canvas");
  can.width = canvas.width;
  can.height = height;
  const ctx2 = can.getContext("2d");
  ctx2.putImageData(imageData, 0, 0);
  return can;
};

export const clipCanvasV2 = (canvas, start, width, height) => {
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, start, width, height);
  const can = document.createElement("canvas");
  can.width = width;
  can.height = height;
  const ctx2 = can.getContext("2d");
  ctx2.putImageData(imageData, 0, 0);
  return can;
};

const PADDING = 100;

const leftSpaceHeight = (height, pageHeight) => {
  let h;
  for (h = 0; h <= height; h += pageHeight);
  return h - height;
};

export const renderAsPDF = async ({
  header = "",
  widget,
  table,
  columns = 2,
  tables = [],
  chartDOMs = [],
  leftPadding,
  rightPadding
}) => {
  const doc = new jsPDF("p", "px", A4_SIZE);

  doc.setFontSize(56);
  doc.setFont("Helvetica");

  doc.text(header, A4_SIZE[0] / 2, 72, { align: "center", baseline: "top" });

  const appLogoCanvas = await captureElement(
    document.getElementsByClassName("navbar-logo")[0]
  );
  const teamLogoCanvas = await captureElement(
    document.getElementById("team-logo")
  );
  doc.addImage(
    appLogoCanvas.toDataURL("image/webp"),
    "webp",
    30,
    30,
    appLogoCanvas.width,
    appLogoCanvas.height
  );
  doc.addImage(
    teamLogoCanvas.toDataURL("image/webp"),
    "webp",
    A4_SIZE[0] - 120 - 30,
    30,
    120,
    120
  );

  let chartStartInd = 0,
    pdfHeight = 0,
    h;
  const pageContentWidth = A4_SIZE[0] - PADDING * 2;
  const pageContentHeight = A4_SIZE[1] - PADDING * 3;

  if (widget) {
    const canvas = await captureElement(widget);
    const width = canvas.width;
    const ratio = pageContentWidth / width;
    const pdfWidgetHeight = canvas.height * ratio;
    pdfHeight += pdfWidgetHeight;
    doc.addImage(
      canvas.toDataURL("image/png"),
      "PNG",
      PADDING,
      PADDING * 2,
      pageContentWidth,
      pdfWidgetHeight
    );
  }

  if (table) {
    const canvas = await captureElement(table);
    const width = canvas.width;
    const ratio = pageContentWidth / width;
    const pdfTableHeight = canvas.height * ratio;
    for (h = 0; h < pdfTableHeight; ) {
      const clipHeight =
        Math.min(
          leftSpaceHeight(h + pdfHeight, pageContentHeight),
          pdfTableHeight - h
        ) / ratio;
      const clipped = clipCanvas(canvas, h / ratio, clipHeight);
      if (h !== 0) doc.addPage();
      doc.addImage(
        clipped.toDataURL("image/png"),
        "PNG",
        PADDING,
        PADDING * 2 + (h === 0) * pdfHeight,
        pageContentWidth,
        clipHeight * ratio
      );
      h += clipHeight * ratio;
    }
    pdfHeight += pdfTableHeight;
  }

  const leftSpace = leftSpaceHeight(pdfHeight, pageContentHeight);
  for (let i = 1; i <= 3; i++) {
    if (leftSpace >= (pageContentHeight / 3) * i) {
      chartStartInd = (3 * columns) - i * columns;
    }
  }

  doc.setFontSize(64);

  const charts = [];
  for (let i = 0; i < chartDOMs.length; i++) {
    charts.push(chartDOMs[i]);
  }

  if (tables.length > 0) {
    let ind = 0, startX = 0, startY = 0, lineHeight = 0;
    for (let i = 0; i < charts.length; i++) {
      startX =
        (((ind % (3 * columns)) % columns) * pageContentWidth) / columns;
      startY =
        (Math.floor((ind % (3 * columns)) / columns) * pageContentHeight) / 3;
      if (ind % (3 * columns) == 0 && !(pdfHeight === 0 && i === 0))
        doc.addPage();

      //------------------------ Chart Section ------------------------
      let chartHeight = pageContentHeight / 3 - PADDING;
      let chartWidth = pageContentWidth / columns;
      const el = charts[i];
      const imgData = await htmlToImage.toPng(el, { pixelRatio: 2, backgroundColor: '#ffffff' });
      doc.addImage(imgData, "PNG", startX, startY + PADDING * 2, chartWidth, chartHeight, `image${i}`);
      lineHeight = Math.max(lineHeight, chartHeight)

      //------------------------ Table Section ------------------------
      ind += 1;
      startX += (((ind % (3 * columns)) % columns) * pageContentWidth) / columns;
      startY = (Math.floor((ind % (3 * columns)) / columns) * pageContentHeight) / 3;
      
      const canvas = await captureElement(tables[i], { scale: (tables[i].rows[0].cells.length > 6 ? 1.25 : 1.5)});
      const tableWidth = canvas.width;
      const tableHeight = canvas.height;
      const clipped = clipCanvasV2(canvas, 0, tableWidth, tableHeight);
      doc.addImage(
        clipped.toDataURL("image/png"),
        "PNG",
        startX + PADDING,
        startY + PADDING * 2.94,
        tableWidth ,
        tableHeight
      );
      lineHeight = Math.max(lineHeight, chartHeight)
      pdfHeight += lineHeight + PADDING;
      ind += 1;
    }  
  }
  else {
    const shouldUseCustomPadding = leftPadding !== undefined && rightPadding !== undefined;
    const chartContentWidth = shouldUseCustomPadding ? 
      A4_SIZE[0] - leftPadding - rightPadding : 
      pageContentWidth;
    
    for (let i = 0; i < charts.length; i++) {
      const ind = chartStartInd + i;
      const startX = (shouldUseCustomPadding ? leftPadding : PADDING) +
        (((ind % (3 * columns)) % columns) * chartContentWidth) / columns;
      const startY =
        (Math.floor((ind % (3 * columns)) / columns) * pageContentHeight) / 3;
      if (ind % (3 * columns) == 0 && !(pdfHeight === 0 && i === 0)) {
        doc.addPage();
      }

      const el = charts[i];
      const scaleCorrectionFactor = .92;
      const width = chartContentWidth / columns;
      const aspectRatio = el.offsetHeight / el.offsetWidth;
      const adjustedHeight = width * aspectRatio;
      
      const imgData = await htmlToImage.toPng(el, {
        pixelRatio: 2,
        backgroundColor: '#ffffff'
      });

      const leftPad = leftPadding === 0 ? 0 : PADDING;
      
      doc.addImage(
        imgData, 
        "PNG", 
        (startX + scaleCorrectionFactor* leftPad), 
        (startY + scaleCorrectionFactor* PADDING * 3),
        scaleCorrectionFactor* width,
        scaleCorrectionFactor* adjustedHeight, 
        `image${i}`
      );

      pdfHeight += adjustedHeight + PADDING * 2;
    }
}

  doc.save("download.pdf");
};

export const downloadBlob = (blob, filename) => {
  // Create a URL for the blob object
  const url = window.URL.createObjectURL(blob);

  // Create an <a> element and set its href to the blob URL
  const a = document.createElement('a');
  a.href = url;
  a.download = filename  || ('download.pdf');

  // Append the <a> element to the document body
  document.body.appendChild(a);

  // Programmatically click the <a> element to trigger the download
  a.click();

  // Clean up by revoking the object URL and removing the <a> element
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}